import React from "react";
import { useQuery } from "@tanstack/react-query";
import CustomerLayout from "@/components/CustomerLayout";
import { CategoryNav } from "@/components/HomeSections";
import api from "@/lib/api";
import { Spinner } from "@/components/States";

export default function AllCategories() {
  const { data: cats } = useQuery({ queryKey: ["cats"], queryFn: () => api.get("/categories").then((r) => r.data) });
  return (
    <CustomerLayout>
      <h1 className="mb-1 font-head text-2xl font-black tracking-tight text-slate-900 sm:text-3xl">Browse categories</h1>
      <p className="mb-6 text-sm text-slate-500">Find exactly what you need from stores near you.</p>
      {!cats ? <div className="flex justify-center py-20"><Spinner className="h-8 w-8" /></div> : <CategoryNav cats={cats} />}
    </CustomerLayout>
  );
}
